import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';

import Filter from '../../components/generics/Filter';
import ReportHeader2 from '../../components/generics/ReportHeader2';
import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import {
  fetchInvoiceReport,
  fetchInvoiceReportSuccess,
  fetchInvoiceReportFailure,
  fetchInvoiceReportCSV,
  fetchInvoiceReportCSVSuccess,
  fetchInvoiceReportCSVFailure,
} from "../../store/reports/actions";

import { fetchShipmentReportCSV_R365, fetchShipmentReportCSV_R365_2 } from "../../store/reports/api";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class Report_R365 extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchVal: ''
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchVal = params.val ? params.val : undefined;

    // Fetch initial page
    this.setState({filterFrom, filterTo, searchVal}, () => {
      this.props.getInvoicesReport(this.state.page, this.state.filterFrom, this.state.filterTo, this.state.searchVal);
    });

    this.props.fetchInvoiceReportCSV(filterFrom, filterTo);
  }

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------


  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE}, () => {
        this.updateQueryString();
        this.searchRefresh(true);
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE}, () => {
        this.updateQueryString();
        this.searchRefresh(true);
    });
  };

  onSearchChange = (event) => {
    let searchVal = event.target.value ? event.target.value : '';
    this.setState({ searchVal, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  searchRefresh = (refreshCSV) => {
    this.props.getInvoicesReport(this.state.page, this.state.filterFrom, this.state.filterTo, this.state.searchVal);
    if (refreshCSV) {
      this.props.fetchInvoiceReportCSV(this.state.filterFrom, this.state.filterTo);
    }
  };

  updateQueryString = () => {
    let params = {};
    if (this.state.filterFrom){
      params.from = this.state.filterFrom;
    }
    if (this.state.filterTo){
      params.to = this.state.filterTo;
    }
    if (this.state.searchVal){
      params.val = this.state.searchVal;
    }
    this.props.history.push({
      search: queryString.stringify(params)
    })
  };

  loadCsv_R365 = () => {
    let fileName = `${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`
    this.setState({
        csvIsloading_R365: true,
    })
    fetchShipmentReportCSV_R365(this.state.filterFrom, this.state.filterTo, this.state.searchInventory).then((r) => {
      let blob = new Blob([r.data], { type: 'text/csv' })
      let link = document.createElement('a')
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', fileName);
      link.click();
      document.body.removeChild(link);
      this.setState({
        csvIsloading_R365: false,
      })
    }).catch((err) => {
      console.log(err);
      this.setState({
        csvIsloading_R365: false,
      })
    });
  };

  loadCsv_R365_2 = () => {
    let fileName = `${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`
    this.setState({
        csvIsloading_R365_2: true,
    })
    fetchShipmentReportCSV_R365_2(this.state.filterFrom, this.state.filterTo, this.state.searchInventory).then((r) => {
      let blob = new Blob([r.data], { type: 'text/csv' })
      let link = document.createElement('a')
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', fileName);
      link.click();
      document.body.removeChild(link);
      this.setState({
        csvIsloading_R365_2: false,
      })
    }).catch((err) => {
      console.log(err);
      this.setState({
        csvIsloading_R365_2: false,
      })
    });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader2 title='Reports R_365'
                          actionClass='btn btn-primary m-0'
                          headers3={['Vendor', 'Location', 'Document Number', 'Date', 'Vendor Item Number', 'Vendor Item Name', 'UofM', 'QTY', 'Unit Price', 'Total Price']}
                          filename3={`${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}Invoice.csv`}
                          csvData3={this.props.invoiceReportCSV.invoiceCSV_R}
                          actionTitle3='Invoice R_365'
                          csvLoading3={this.props.invoiceReportCSV.loading}
                          tercer_csv={true}
                          actionTitle2='Shipment CSV R365 AR'
                          csvLoading2={this.state.csvIsloading_R365}
                          fromFile2={true}
                          loadCsv2={this.loadCsv_R365}
                          actionTitle='Shipment CSV R365 AP'
                          csvLoading={this.state.csvIsloading_R365_2}
                          fromFile={true}
                          loadCsv={this.loadCsv_R365_2}
            />
            <Filter
              searchLabel="Search Inventory"
              searchPlaceholder="Search by Name"
              searchVal={this.state.searchInventory}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
            />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    invoicesReport: state.reports.invoicesReport,
    invoiceReportCSV: state.reports.invoiceReportCSV,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoicesReport: (page, from, to, search='') => {
      dispatch(fetchInvoiceReport(page, from, to, search)).payload.then((response) => {
        dispatch(fetchInvoiceReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchInvoiceReportFailure(error));
      });
    },
    fetchInvoiceReportCSV: (from, to) => {
      dispatch(fetchInvoiceReportCSV(from, to)).payload.then((response) => {
        dispatch(fetchInvoiceReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchInvoiceReportCSVFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Report_R365));
